var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMasterCard = function SvgMasterCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M17.662 2.498h-7.493v13.465h7.493z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M10.645 9.23a8.55 8.55 0 0 1 3.27-6.732 8.564 8.564 0 1 0 0 13.465 8.55 8.55 0 0 1-3.27-6.733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M27.77 9.23a8.562 8.562 0 0 1-13.855 6.733 8.566 8.566 0 0 0 0-13.465A8.563 8.563 0 0 1 27.77 9.23"
  })));
};
export default SvgMasterCard;